import React from 'react';

import frameSrc from 'src/images/laptop-frame.png';
import replaySrc from 'src/images/replay_3d.jpg';
import { intercomAppID } from 'src/config';
import './intro.css';

export default class Intro extends React.Component {
  render() {
    return (
      <section className="intro">
        <div className="intro-background" />
        <div className="intro-content">
          <div className="container">
            <h1 className="intro-title">
              Next-generation scouting and analytics for esports professionals
            </h1>
            <div className="intro-action">
              <a
                className="button intro-button intercom"
                href={`mailto:${intercomAppID}@incoming.intercom.io`}>
                Contact us
              </a>
            </div>
          </div>
          <figure className="intro-figure">
            <img className="contain" src={frameSrc} alt="Laptop" />
            <div className="intro-figure-frame">
              <img className="contain" src={replaySrc} alt="Replay viewer" />
            </div>
          </figure>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/intro.js